<script setup lang="ts">
import type { CmsElementCrossSelling } from "@shopware/composables";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import ProductSlideCard from "~/components/cms/element/ProductSlideCard.vue";
const { t, locale } = useI18n();
const props = defineProps<{
  content: CmsElementCrossSelling;
}>();

const currentTabIndex = ref<number>(0);

const crossSellCollections = computed(() => {
  return (
    props.content?.data?.crossSellings?.filter(
      (collection) => !!collection.products.length
    ) || []
  );
});

const crossSelling = computed(() => {
  return crossSellCollections.value?.find((collection) =>
    ["Ähnliche Produkte", "D'autre recommendations"].includes(
      collection.crossSelling?.translated?.name
    )
  );
});
const productSlider = ref(null);

const settings = {
  itemsToShow: 5,
  itemsToScroll: 5,
  wrapAround: false,
  snapAlign: "start" as "start",
  autoplay: 0,
  transition: 600,
  pauseAutoplayOnHover: true,
  breakpoints: {
    // 200px and up
    200: {
      itemsToShow: 1,
      itemsToScroll: 1,
      snapAlign: "center" as "center",
    },
    400: {
      itemsToShow: 1,
      itemsToScroll: 1,
      snapAlign: "start",
    },
    600: {
      itemsToShow: 2,
      itemsToScroll: 2,
      snapAlign: "start",
    },
    900: {
      itemsToShow: 3,
      itemsToScroll: 3,
      snapAlign: "start",
    },
    1200: {
      itemsToShow: 4,
      itemsToScroll: 4,
      snapAlign: "start",
    },
  },
};
const currentSlide = ref(0);
const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);

const itemsToShow = computed(() => {
  return productSlider?.value?.data?.config?.itemsToShow;
});

const showNavigation = computed(() => {
  return itemsToShow.value < crossSelling?.value.products?.length;
});
</script>

<template>
  <div ref="crossSellContainer" class="cms-element-cross-selling">
    <div class="container max-w-[90rem] laptop:px-10">
      <div v-if="crossSelling?.products">
        <div id="ProductsCarousel" class="-mx-2.5">
          <Carousel
            v-bind="settings"
            ref="productSlider"
            v-model="currentSlide"
          >
            <Slide v-for="product of crossSelling?.products" :key="product.id">
              <ProductSlideCard :product="product"></ProductSlideCard>
            </Slide>
            <template  v-if="showNavigation" #addons>
              <div
                class="carousel__navigation-button z-0 absolute bottom-0 md:bottom-auto top-1/4 md:top-2/4 max-w-[90rem] flex justify-between -left-15 -right-15 sm:left-0 sm:right-0 sm:left-15 sm:right-15 mx-auto px-3 laptop:px-10 [&>button]:static"
              >
                <Navigation>
                  <template #next>
                    <img
                      src="assets/icons/slide-right.svg"
                      alt="Next"
                      class="w-6 h-6"
                    />
                  </template>
                  <template #prev>
                    <img
                      src="assets/icons/slide-left.svg"
                      alt="Previous"
                      class="w-6 h-6"
                    />
                  </template>
                </Navigation>
              </div>
            </template>
          </Carousel>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
